import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ProductCreateWfoodcostAllergensPage } from "../../product-create/product-create-without-foodcost/product-create-wfoodcost-allergens/product-create-wfoodcost-allergens";

/**
 * Generated class for the ProductViewAllergensPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-product-view-allergens',
    templateUrl: 'product-view-allergens.html',
})
export class ProductViewAllergensPage {
    @Input() product: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams) {
    }

    edit() {
        this.navCtrl.push(ProductCreateWfoodcostAllergensPage, {
            update_state: true,
            product_uid: this.product.UID,
            allergens: this.product.allergens,
            product_name: this.product.name,
            product: this.product
        })
    }

}



// WEBPACK FOOTER //
// ./src/pages/products/product-view/product-view-allergens/product-view-allergens.ts